import { z } from 'zod';
import { TFunction } from 'i18next';

export const createContactSchema = (t: TFunction) =>
  z.object({
    title: z.string().optional(),
    name: z.string().min(1, t('validation.required', 'Name is mandatory')),
    jobTitle: z.string().optional(),
    address: z.string().optional(),
    email1: z
      .string()
      .min(1, t('validation.required', 'Primary Email is mandatory'))
      .email(t('validation.invalidEmail', 'Invalid email format')),
    email2: z.string().email(t('validation.invalidEmail', 'Invalid email format')).optional().or(z.literal('')),
    email3: z.string().email(t('validation.invalidEmail', 'Invalid email format')).optional().or(z.literal('')),
    phone1: z.string().min(1, t('validation.required', 'Primary Phone is mandatory')),
    phone2: z.string().optional(),
    phone3: z.string().optional(),
    orgId: z.number().optional()
  });

export type ContactFormValues = z.infer<ReturnType<typeof createContactSchema>>;

export const DEFAULT_CONTACT_VALUES: ContactFormValues = {
  title: '',
  name: '',
  jobTitle: '',
  address: '',
  email1: '',
  email2: '',
  email3: '',
  phone1: '',
  phone2: '',
  phone3: '',
  orgId: undefined
};
